import { render } from "./ErrorRedIcon.vue?vue&type=template&id=13fa4e22"
import script from "./ErrorRedIcon.vue?vue&type=script&lang=js"
export * from "./ErrorRedIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__